import React, { useState } from 'react';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from './ui/dialog';
import { Button } from './ui/button';
import { Input } from './ui/input';
import { Textarea } from './ui/textarea';
import { Label } from './ui/label';
import { CheckCircle2 } from 'lucide-react';

const DemoRequestModal = ({ open, onOpenChange }) => {
  const [formData, setFormData] = useState({
    name: '',
    organization: '',
    email: '',
    phone: '',
    preferredDate: '',
    message: ''
  });
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log('Demo Request:', formData);
    setSubmitted(true);
    setTimeout(() => {
      setSubmitted(false);
      onOpenChange(false);
      setFormData({
        name: '',
        organization: '',
        email: '',
        phone: '',
        preferredDate: '',
        message: ''
      });
    }, 2000);
  };

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-2xl max-h-[90vh] overflow-y-auto">
        {!submitted ? (
          <>
            <DialogHeader>
              <DialogTitle className="text-3xl font-bold text-[#0B0F14]">
                Request Platform Demo
              </DialogTitle>
              <DialogDescription className="text-lg text-[#5F6B7A]">
                See our real-time tracking platform in action. Schedule a personalized demo.
              </DialogDescription>
            </DialogHeader>
            
            <form onSubmit={handleSubmit} className="space-y-6 mt-6">
              <div className="grid md:grid-cols-2 gap-4">
                <div>
                  <Label htmlFor="name" className="text-[#0B0F14] font-semibold">
                    Full Name *
                  </Label>
                  <Input
                    id="name"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    required
                    className="mt-2"
                    placeholder="John Smith"
                  />
                </div>
                
                <div>
                  <Label htmlFor="organization" className="text-[#0B0F14] font-semibold">
                    Organization *
                  </Label>
                  <Input
                    id="organization"
                    name="organization"
                    value={formData.organization}
                    onChange={handleChange}
                    required
                    className="mt-2"
                    placeholder="School District / Organization"
                  />
                </div>
              </div>

              <div className="grid md:grid-cols-2 gap-4">
                <div>
                  <Label htmlFor="email" className="text-[#0B0F14] font-semibold">
                    Email Address *
                  </Label>
                  <Input
                    id="email"
                    name="email"
                    type="email"
                    value={formData.email}
                    onChange={handleChange}
                    required
                    className="mt-2"
                    placeholder="your@email.com"
                  />
                </div>
                
                <div>
                  <Label htmlFor="phone" className="text-[#0B0F14] font-semibold">
                    Phone Number *
                  </Label>
                  <Input
                    id="phone"
                    name="phone"
                    type="tel"
                    value={formData.phone}
                    onChange={handleChange}
                    required
                    className="mt-2"
                    placeholder="(555) 123-4567"
                  />
                </div>
              </div>

              <div>
                <Label htmlFor="preferredDate" className="text-[#0B0F14] font-semibold">
                  Preferred Demo Date/Time
                </Label>
                <Input
                  id="preferredDate"
                  name="preferredDate"
                  value={formData.preferredDate}
                  onChange={handleChange}
                  className="mt-2"
                  placeholder="e.g., Next week, Tuesdays 2-4pm"
                />
              </div>

              <div>
                <Label htmlFor="message" className="text-[#0B0F14] font-semibold">
                  Additional Information
                </Label>
                <Textarea
                  id="message"
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  className="mt-2"
                  rows={3}
                  placeholder="Any specific features you'd like to see or questions you have..."
                />
              </div>

              <div className="flex gap-4">
                <Button
                  type="submit"
                  className="flex-1 bg-gradient-to-r from-[#0077BE] to-[#00B4D8] text-white hover:shadow-xl py-6 text-lg font-semibold rounded-xl"
                >
                  Schedule Demo
                </Button>
                <Button
                  type="button"
                  variant="outline"
                  onClick={() => onOpenChange(false)}
                  className="px-8 py-6 rounded-xl"
                >
                  Cancel
                </Button>
              </div>
            </form>
          </>
        ) : (
          <div className="py-12 text-center">
            <div className="w-20 h-20 rounded-full bg-[#2ECC71]/20 flex items-center justify-center mx-auto mb-6">
              <CheckCircle2 className="w-12 h-12 text-[#2ECC71]" />
            </div>
            <h3 className="text-2xl font-bold text-[#0B0F14] mb-3">
              Demo Request Received!
            </h3>
            <p className="text-lg text-[#5F6B7A]">
              We'll contact you shortly to schedule your personalized platform demo.
            </p>
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
};

export default DemoRequestModal;
